export const ENGAGEMENT_CREATE_POLL_IMPRESSION = {
    url: '/trk/engagement:create_poll_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const ENGAGEMENT_CREATE_QUESTION_IMPRESSION = {
    url: '/trk/engagement:create_question_impression',
    isUserEngagement: false,
    consent: 'essential',
};
export const ENGAGEMENT_SUBMIT_POLL_RESPONSE = {
    url: '/trk/engagement:submit_poll_response',
    isUserEngagement: true,
    consent: 'essential',
};
export const ENGAGEMENT_SUBMIT_QUESTION_RESPONSE = {
    url: '/trk/engagement:submit_question_response',
    isUserEngagement: true,
    consent: 'essential',
};
